exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Label {\n  font-size: 10px;\n  line-height: 1.6;\n  text-transform: uppercase;\n  font-weight: 700;\n  color: #738495;\n  float: left;\n  width: 100%;\n  margin-bottom: 7px;\n  letter-spacing: 1px; }\n", ""]);

// exports
